/**
 * Sets and rounds a rating to the nearest tenth
 * within the allowed range of 0 to 50.
 * Example: 34.2 -> 34, -2 -> 0, 99 -> 50
 */
export const normalizeRatingTenths = (value: number): number =>
  Math.max(0, Math.min(50, Math.round(value)))

/**
 * Format "out of 5" display string without trailing .0
 * Example: 34 -> "3.4", 30 -> "3"
 */
export const formatRatingOutOfFive = (tenths: number): string => {
  const outOfFive = tenths / 10
  return Number.isInteger(outOfFive) ? String(outOfFive) : outOfFive.toFixed(1)
}

/**
 * For a 0..50 tenths rating, return 5 fill values (0..1) for each star.
 * Example: 34 -> [1,1,1,0.4,0]
 */
export const starFillFractions = (tenths: number): number[] => {
  const ratingOutOfFive = tenths / 10
  return Array.from({ length: 5 }, (_, i) => Math.max(0, Math.min(1, ratingOutOfFive - i)))
}
